import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/accordions/FaqWithButton.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/ParallaxContainer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/HRMSPrice.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/headers/Header1.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/headers/HeaderPreviewfinal.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/homes/home-1/heros/Hero1.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homes/home-1/heros/Hero2.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homes/home2/Pricing.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homes/home2/Slider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homes/home2/Testimonials.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/others/ClientSlider.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
